'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderInputComponent = exports.renderSectionTitle = exports.renderSuggestion = undefined;

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LocationIcon = require('../icons/LocationIcon');

var _LocationIcon2 = _interopRequireDefault(_LocationIcon);

var _CamIcon = require('../icons/CamIcon');

var _CamIcon2 = _interopRequireDefault(_CamIcon);

var _SearchIcon = require('../icons/SearchIcon');

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

var _BackIcon = require('../icons/BackIcon');

var _BackIcon2 = _interopRequireDefault(_BackIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var renderSuggestion = exports.renderSuggestion = function renderSuggestion(searchTerm) {
  return function (suggestion) {
    var _suggestion$_source = suggestion._source,
        cams = _suggestion$_source.cams,
        breadCrumbs = _suggestion$_source.breadCrumbs,
        name = _suggestion$_source.name,
        _type = suggestion._type;


    var indexOfSearchTerm = name.toLowerCase().indexOf(searchTerm.toLowerCase());
    var nameContent = void 0;
    if (indexOfSearchTerm > -1) {
      var searchTermLength = searchTerm.length;
      var resultTermLength = name.length;
      var endOfHighlight = indexOfSearchTerm + searchTermLength;
      nameContent = _react2.default.createElement(
        'a',
        null,
        name.substring(0, indexOfSearchTerm),
        _react2.default.createElement(
          'highlight',
          null,
          name.substring(indexOfSearchTerm, endOfHighlight)
        ),
        name.substring(endOfHighlight, resultTermLength)
      );
    } else {
      nameContent = _react2.default.createElement(
        'a',
        null,
        name
      );
    }

    var camClassName = '';
    var iconContent = '';
    var types = ['geoname', 'subregion', 'spot'];
    if (types.indexOf(_type) > -1) {
      if (cams && cams.length) {
        camClassName = 'quiver-spot-search__react-autosuggest__container__icon__hd-cam';
        iconContent = _react2.default.createElement(_CamIcon2.default, null);
      } else {
        camClassName = 'quiver-spot-search__react-autosuggest__container__icon__location';
        iconContent = _react2.default.createElement(_LocationIcon2.default, null);
      }
    }

    var breadcrumb = breadCrumbs ? breadCrumbs.join(' / ') : '';
    return _react2.default.createElement(
      'div',
      { className: camClassName },
      iconContent,
      nameContent,
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'div',
        { className: 'quiver-spot-search__react-autosuggest__container__subtitle' },
        breadcrumb
      )
    );
  };
};

var renderSectionTitle = exports.renderSectionTitle = function renderSectionTitle(section) {
  var hits = section.hits.hits,
      suggest = section.suggest;


  var suggestTypes = new _map2.default();
  suggestTypes.set('spot-suggest', 'Surf Spots');
  suggestTypes.set('subregion-suggest', 'Forecast');
  suggestTypes.set('geoname-suggest', 'Map Area');

  if (suggest) {
    var ret = (0, _from2.default)(suggestTypes.entries()).find(function (entry) {
      return suggest[entry[0]] && (suggest[entry[0]][0].options.length > 0 || hits.length > 0);
    });
    if (ret) return ret[1];
  }
  return null;
};

/* eslint-disable max-len */
var renderInputComponent = exports.renderInputComponent = function renderInputComponent(isMobileExpanded, handleToggleSearchOffClick, handleToggleSearchOnClick) {
  return function (inputProps) {
    var mobileVersion = void 0;
    if (isMobileExpanded) {
      mobileVersion = _react2.default.createElement(
        'div',
        { className: 'quiver-spot-search__react-autosuggest__container__wrapper-mobile-expanded' },
        _react2.default.createElement(
          'div',
          {
            className: 'quiver-spot-search__react-autosuggest__container__wrapper-mobile-expanded__back',
            onClick: handleToggleSearchOffClick
          },
          _react2.default.createElement(_BackIcon2.default, null)
        ),
        _react2.default.createElement('input', inputProps),
        _react2.default.createElement('div', { className: 'quiver-spot-search__react-autosuggest__container__wrapper-mobile-expanded__background' })
      );
    } else {
      mobileVersion = _react2.default.createElement(
        'div',
        {
          className: 'quiver-spot-search__react-autosuggest__container__wrapper-mobile-button',
          onClick: handleToggleSearchOnClick
        },
        _react2.default.createElement(_SearchIcon2.default, null)
      );
    }

    return _react2.default.createElement(
      'div',
      { className: 'quiver-spot-search__react-autosuggest__container__wrapper' },
      mobileVersion,
      _react2.default.createElement(
        'div',
        { className: 'quiver-spot-search__react-autosuggest__container__wrapper-desktop' },
        _react2.default.createElement(_SearchIcon2.default, null),
        _react2.default.createElement('input', inputProps)
      )
    );
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SpotSearch/SpotSuggestion/SpotSuggestionRender.js
// module id = 657
// module chunks = 11